import { render, staticRenderFns } from "./InactiveFBMUsersTableMobile.vue?vue&type=template&id=7526adf1&scoped=true"
import script from "./InactiveFBMUsersTableMobile.vue?vue&type=script&lang=js"
export * from "./InactiveFBMUsersTableMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7526adf1",
  null
  
)

export default component.exports